import { createContext, useContext } from 'react'

export const PatientCentralContext = createContext<any>({})

export const usePatientCentralContext = () => {
  const context = useContext(PatientCentralContext)
  return context
}
